export default __webpack_public_path__ + "static/media/Raja Krishnamoorthi.39011d43.jpg";